<script lang="ts" setup>
  import { LogoText } from '../../../../shared/ui/logo-text';
  import SettingsCogPath from '../SettingsCogPath.vue';
  import HeaderButton from './HeaderButton.vue';

  defineProps<{ hasSettings: boolean }>();
  defineEmits<{ rulesClick: [button: HTMLElement]; settingsClick: [] }>();
</script>

<template>
  <header class="lobby-header">
    <HeaderButton class="rules-button" label="How to play" @click="$emit('rulesClick', $event)">
      <circle cx="12" cy="12" r="10" />
      <line x1="12" x2="12" y1="16" y2="12" />
      <line x1="12" x2="12.01" y1="8" y2="8" />
    </HeaderButton>
    <LogoText class="logo-text" text="Songstar" />
    <HeaderButton v-if="hasSettings" class="settings-button" label="Settings" @click="$emit('settingsClick')">
      <SettingsCogPath />
      <circle cx="12" cy="12" r="3" />
    </HeaderButton>
  </header>
</template>

<style scoped>
  .lobby-header {
    --header-button-inset: 0.75rem;
    --header-button-width: 5.5rem;

    align-items: center;
    display: flex;
    justify-content: center;
    margin-bottom: 0.5rem;
    padding: 1rem var(--view-gutter) 0;
    position: relative;
    width: 100%;
  }

  .rules-button {
    left: var(--header-button-inset);
    position: absolute;
    top: var(--header-button-inset);
    width: var(--header-button-width);
  }

  .settings-button {
    position: absolute;
    right: var(--header-button-inset);
    top: var(--header-button-inset);
    width: var(--header-button-width);
  }

  .logo-text {
    font-size: var(--font-size-xl);
    text-align: center;
  }
</style>
